import * as actionTypes from "./customiseTypes";
import themeConfiguration from "../../configs/themeConfiguration";

const INITIAL_STATE = {
    theme: themeConfiguration.theme,
    contentWidth: themeConfiguration.contentWidth,
    sidebarCollapsed: themeConfiguration.sidebarCollapsed,
    sidebarCollapseButton: themeConfiguration.sidebarCollapseButton,
    layout: themeConfiguration.layout,
    navigationFull: themeConfiguration.navigationFull,
    navigationBg: themeConfiguration.navigationBg,
    direction: themeConfiguration.direction,
    language: themeConfiguration.language,
};

const customiseReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.THEME:
            return {
                ...state,
                theme: action.payload,
            };

        case actionTypes.CONTENT_WIDTH:
            return {
                ...state,
                contentWidth: action.payload,
            };

        case actionTypes.SIDEBAR_COLLAPSED:
            return {
                ...state,
                sidebarCollapsed: action.payload,
            };

        case actionTypes.SIDEBAR_COLLAPSE_BUTTON:
            return {
                ...state,
                sidebarCollapseButton: action.payload,
            };

        case actionTypes.LAYOUT_CHANGE:
            return {
                ...state,
                layout: action.payload,
            };

        case actionTypes.NAVIGATION_FULL:
            return {
                ...state,
                navigationFull: action.payload,
            };

        case actionTypes.NAVIGATION_BG:
            return {
                ...state,
                navigationBg: action.payload,
            };

        case actionTypes.DIRECTION:
            return {
                ...state,
                direction: action.payload,
            };

        case actionTypes.LANGUAGE:
            return {
                ...state,
                language: action.payload,
            };

        default:
            return state;
    }
};

export default customiseReducer;
